import { BsStar, BsStarFill } from "react-icons/bs";

export const Testimonial4 = () => {
  return (
    <div className="text-white bg-[#141414] border border-[#292929] rounded-3xl lg:p-12 p-4 flex flex-col gap-y-8 h-full w-full">
      <div className="">
        <div></div>
        <div className="flex gap-x-4">
          <img className="w-12 h-12 rounded-full" src="/user.png" />
          <div>
            <h6 className="lg:text-xl text-base font-bold">Maria</h6>

            <div className="flex text-xs text-[#BFBFBF] font-light gap-x-2">
              <p>Founder at</p>
              <span>EcoNest</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-y-4">
        <p className="md:text-2xl text-lg  font-bold">
          “Alertify has transformed how we handle client communication and reporting.”
        </p>
        <p className="md:text-base text-xs font-light text-[#BFBFBF]">
          With Alertify, we can deliver better service to our clients. It’s user-friendly, fast, and has made organizing project updates and sharing them a breeze.
        </p>
      </div>
      <div className="flex flex-col gap-y-3">
        <div className="flex items-center gap-2 w-fit rounded-full px-4 py-1 text-[#A4F720] bg-[#A4F72014] border border-[#A4F7201F]">
          <BsStarFill />
          <div className="lg:text-sm text-xs">Favorite Features</div>
        </div>
        <div className="flex gap-x-4">
          <div className="flex flex-col bg-[#1F1F1F] border border-[#292929] rounded-xl p-4 gap-y-2">
            <h6 className="lg:text-base text-sm font-bold ">Centralized Dashboards</h6>
            <p className="lg:text-sm text-xs font-light text-[#BFBFBF]">
              Having everything in one place simplifies tracking client projects.
            </p>
          </div>
          <div className="flex flex-col bg-[#1F1F1F] border border-[#292929] rounded-xl p-4 gap-y-2">
            <h6 className="text-base font-bold ">User Statistics</h6>
            <p className="text-sm font-light text-[#BFBFBF]">
              The detailed user insights allow us to identify trends and make data-driven decisions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
